export default async function WorkspaceNotification(
  groupName,
  linkData,
  addedByName,
  workspaceUrl,
  domainUrl,
  groupToken
) {
  const workspaceLink = `${workspaceUrl}?group=${groupToken}`
  const categoryHtml = linkData.category
    ? `<span style="display:inline-block;background:#1976d2;color:#ffffff;padding:4px 12px;border-radius:8px;font-size:12px;font-weight:500;">${linkData.category}</span>`
    : ''

  const template = await fetch(
    '/email-templates/html/workspace/notification.html'
  ).then(response => response.text())

  return template
    .replace(/\{\{groupName\}\}/g, groupName)
    .replace(/\{\{addedByName\}\}/g, addedByName)
    .replace(/\{\{linkTitle\}\}/g, linkData.title || '')
    .replace(/\{\{linkUrl\}\}/g, linkData.link || '')
    .replace(/\{\{categoryHtml\}\}/g, categoryHtml)
    .replace(/\{\{workspaceLink\}\}/g, workspaceLink)
    .replace(/\{\{domainUrl\}\}/g, domainUrl)
}
